import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ValueProp from "@/components/ValueProp";
import SubscriptionTeaser from "@/components/SubscriptionTeaser";
import Clients from "@/components/Clients";
import FeaturedVideo from "@/components/FeaturedVideo";
import About from "@/components/About";
import UseCases from "@/components/UseCases";
import Footer from "@/components/Footer";
import ContactModal from "@/components/ContactModal";
import PaymentOptions from "@/components/PaymentOptions";
import Subscription from "@/components/Subscription";
import Pricing from "@/components/Pricing";
import ScrollToTop from "@/components/ScrollToTop";

const LandingPage = () => {
  const [contactOpen, setContactOpen] = useState(false);
  const openContact = () => setContactOpen(true);

  return (
    <div className="bg-[#050505] text-white min-h-screen" data-testid="landing-page">
      <Header onContact={openContact} />
      <main>
        <Hero />
        <ValueProp />
        <SubscriptionTeaser />
        <Clients />
        <FeaturedVideo />
        <About />
        <UseCases />
      </main>
      <Footer onContact={openContact} />
      <ContactModal open={contactOpen} onOpenChange={setContactOpen} />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: 0,
            fontFamily: "Montserrat, sans-serif",
            fontSize: "12px",
            letterSpacing: "0.05em",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/payment" element={<PaymentOptions />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/pricing" element={<Pricing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
